module.exports = "https://static.energy5.com/_next/static/images/e1-46ffa006ff0fc277c59969092150f32c.png";